import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { PageHeader, Tabs, Spin } from "antd";
import DashboardProcesos from "../DashboardProcesos/DashboardProcesos";
import TableroPersonal from "./TableroPersonal";
import ReporteProduccionSemanal from "./ReporteProduccionSemanal";

const { TabPane } = Tabs;

// Dashboard de Taxidermia: reemplaza al "Dashboard de Etapas".
// - Por persona: quien trabaja cada pieza en las etapas con control por persona.
// - Por etapa: el Kanban de siempre (DashboardProcesos).
// - Reporte semanal: la libreta de produccion del taller.
//
// Abre en "Por persona" solo si alguna etapa lleva control por persona; si no, en "Por etapa",
// que es exactamente lo que habia antes. Cada pestaña se monta al entrar, asi que siempre
// muestra datos frescos despues de mover piezas en la otra.
class DashboardTaxidermia extends Component {
  state = { tab: null };

  componentDidMount() {
    axios
      .post("etapas/selectEtapas", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        const hayControladas =
          res.data.success === 2 && (res.data.etapas || []).some((e) => e.controlPorPersona === true);
        this.setState({ tab: hayControladas ? "persona" : "etapa" });
      })
      .catch(() => this.setState({ tab: "etapa" }));
  }

  render() {
    const { tab } = this.state;
    return (
      <>
        <PageHeader
          title="Dashboard de Taxidermia"
          style={{ border: "1px solid #ebedf0", backgroundColor: "white", marginBottom: 10 }}
        />
        {tab === null ? (
          <Spin style={{ display: "block", padding: 40 }} />
        ) : (
          <div style={{ backgroundColor: "white", padding: "0 16px 16px 16px", border: "1px solid #ebedf0" }}>
            <Tabs activeKey={tab} onChange={(nuevo) => this.setState({ tab: nuevo })}>
              <TabPane tab="Por persona" key="persona">
                {tab === "persona" && <TableroPersonal />}
              </TabPane>
              <TabPane tab="Por etapa" key="etapa">
                {tab === "etapa" && <DashboardProcesos embebido />}
              </TabPane>
              <TabPane tab="Reporte semanal" key="reporte">
                {tab === "reporte" && <ReporteProduccionSemanal />}
              </TabPane>
            </Tabs>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(DashboardTaxidermia);
